import { Auth0Provider } from '@auth0/auth0-react';
import config from "./config";
import AppRoutes from "./routes/routes";
import UserSync from "./components/UserSync";
import store from "./store";
import { Provider } from "react-redux";
import "./App.css";

// Handle redirect after Auth0 login - navigate to the original page
const onRedirectCallback = (appState) => {
  // Check sessionStorage first (set by authManager when token refresh fails)
  // Then check appState (set by Auth0Provider's loginWithRedirect)
  const storedReturnTo = sessionStorage.getItem('auth0_return_to');
  const returnTo = storedReturnTo || appState?.returnTo || '/';

  // Clear the stored return URL
  sessionStorage.removeItem('auth0_return_to');

  // Use replace to navigate and avoid callback URL in browser history
  window.location.replace(returnTo);
};

function App() {
  return (
      <Auth0Provider
        domain={config.auth0.domain}
        clientId={config.auth0.clientId}
        authorizationParams={{
          redirect_uri: config.auth0.redirectUri,
          audience: config.auth0.audience,
          scope: config.auth0.scope
        }}
        cacheLocation={config.auth0.cacheLocation}
        useRefreshTokens={config.auth0.useRefreshTokens}
        onRedirectCallback={onRedirectCallback}
      >
        <Provider store={store}>
          <UserSync>
            <AppRoutes />
          </UserSync>
        </Provider>
      </Auth0Provider>
  );
}

export default App;